// import lottie from 'lottie-web'
import gsap from 'gsap'

export const motion = () => {
	icon()
}

const icon = () => {

	// let el = document.querySelector('[data-lottie="icon"]')

	// if (!el) return

	// let animation = lottie.loadAnimation({
	// 	container: el,
	// 	renderer: 'svg',
	// 	loop: false,
	// 	autoplay: false,
	// 	path: '/wp-content/themes/theme-2025/dist/json/icon.json'
	// })

	// animation.play()

}

export default () => { }